import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useNavigate } from '@tanstack/react-router';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import BackIcon from '@mui/icons-material/ArrowBack';

import ContentView from '~/components/ContentView';
import RouteForm from '~/components/RouteForm';
import { useCreateRoute } from '~/hooks/api/useCreateRoute';
import { useDepots } from '~/hooks/api/useDepots';
import messages from './messages';

export const RouteCreate = () => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const { data: depotsData, isLoading: isLoadingDepots } = useDepots({
    perPage: 9999,
  });

  const createRouteMutation = useCreateRoute({
    onSuccess: () => {
      showSnackbar({
        message: intl.formatMessage(messages.saveSuccess),
      });
      navigate({ to: '/trolley-routes' });
    },
    onError: () => {
      showSnackbar({
        message: intl.formatMessage(messages.saveFailure),
      });
    },
  });

  const handleBackButton = () => {
    navigate({ to: '/trolley-routes' });
  };

  const isFetching = isLoadingDepots;
  const depots = depotsData?.data ?? [];

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="back"
              onClick={handleBackButton}
              sx={{ mr: 2 }}
              size="large"
            >
              <BackIcon />
            </IconButton>
            <Typography variant="h6" sx={{ flex: 1 }}>
              <FormattedMessage {...messages.title} />
            </Typography>
          </Toolbar>
        </AppBar>
      }
      isLoading={createRouteMutation.isPending || isFetching}
    >
      {!isFetching && (
        <RouteForm
          onSubmit={(values) => {
            const {
              assignmentRange,
              assignmentRangeFirstShift,
              assignmentRangeLastShift,
              enableAssignmentRangeFirstShift,
              enableAssignmentRangeLastShift,
            } = values;

            createRouteMutation.mutate({
              name: values.name,
              meetingPlace: values.meetingPlace,
              depotId: values.depot,
              evenNumberOfParticipants: values.evenNumberOfParticipants,
              keepRouteStaffed: values.keepRouteStaffed,
              brotherRequirement: values.brotherRequirement,
              assignmentRange: assignmentRange,
              assignmentRangeFirstShift:
                enableAssignmentRangeFirstShift && assignmentRangeFirstShift
                  ? assignmentRangeFirstShift
                  : null,
              assignmentRangeLastShift:
                enableAssignmentRangeLastShift && assignmentRangeLastShift
                  ? assignmentRangeLastShift
                  : null,
            });
          }}
          availableDepots={depots}
          initialValues={{
            assignmentRange: {
              minPublishers: 2,
              maxPublishers: 10,
            },
          }}
        />
      )}
    </ContentView>
  );
};

export default RouteCreate;
